import { ChargingSessionStatus } from '../types'

export const chargingSessionStatusTranslationKeys: Record<ChargingSessionStatus, string> = {
  UNKNOWN: 'emobility.chargingSession.chargingSessionStatus.UNKNOWN',
  CHARGING: 'emobility.chargingSession.chargingSessionStatus.CHARGING',
  WAIT_PV: 'emobility.chargingSession.chargingSessionStatus.WAIT_PV',
  WAIT_AUTHENTICATION: 'emobility.chargingSession.chargingSessionStatus.WAIT_AUTHENTICATION',
  WAITING_AFTER_SUCCESSFUL_AUTHENTICATION: 'emobility.chargingSession.chargingSessionStatus.WAITING_AFTER_SUCCESSFUL_AUTHENTICATION',
  ERROR: 'emobility.chargingSession.chargingSessionStatus.ERROR',
  UNAUTHORIZED: 'emobility.chargingSession.chargingSessionStatus.UNAUTHORIZED',
  FINISHED: 'emobility.chargingSession.chargingSessionStatus.FINISHED',
  SETUP: 'emobility.chargingSession.chargingSessionStatus.SETUP',
  DISCHARGING: 'emobility.chargingSession.chargingSessionStatus.DISCHARGING',
  STANDBY: 'emobility.chargingSession.chargingSessionStatus.STANDBY',
  FINISHED_NO_ACTION: 'emobility.chargingSession.chargingSessionStatus.FINISHED_NO_ACTION',
  EMERGENCY_EXIT: 'emobility.chargingSession.chargingSessionStatus.EMERGENCY_EXIT',
  FULL: 'emobility.chargingSession.chargingSessionStatus.FULL',
  WAIT: 'emobility.chargingSession.chargingSessionStatus.WAIT',
  NULL: '-',
}
